// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__e7R_v","img":"styles_img__U4TO_","link":"styles_link__pbfFa"};